import { useFormikContext } from "formik";

import { InputAdornment, IconButton, MenuItem } from "@material-ui/core";
import { DoubleArrow } from "@material-ui/icons";

import { FormikSelect } from "src/components/form/Select";

import { DISPOSITION_NEXT_ACTIONS } from "./Question";
import { Values } from "./types";

export default function NextQuestion({
  name,
  value,
  questionKey,
  enablePatchThru,
  onGoToQuestion,
  onCreateFollowupQuestion,
  className
}: {
  name: string;
  value: string;
  questionKey: string;
  enablePatchThru: boolean;
  onGoToQuestion: (questionKey: string) => void;
  onCreateFollowupQuestion: () => void;
  className?: string;
}): JSX.Element {
  const { values } = useFormikContext<Values>();
  const nonNextQuestionActions = DISPOSITION_NEXT_ACTIONS.concat([
    "PATCH_THRU"
  ]);

  return (
    <FormikSelect
      fast
      fullWidth
      label="Action"
      name={name}
      className={className}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {value && !nonNextQuestionActions.includes(value) ? (
              <IconButton
                onClick={() => {
                  const questionIdx = value!;
                  onGoToQuestion(questionIdx);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                <DoubleArrow />
              </IconButton>
            ) : (
              ""
            )}
          </InputAdornment>
        )
      }}
      overrideFormikProps={props => ({
        ...props,
        onChange: (evt: React.ChangeEvent<HTMLInputElement>) => {
          if (evt.target.value === "__new__") {
            // if they selected the +New option, create a follow-up question
            onCreateFollowupQuestion();
          } else {
            // otherwise, just use the default formik behavior to update the
            // "next" property of this answer
            props.onChange(evt);
          }
        },
        value: value || ""
      })}
    >
      <MenuItem value={""}>End survey</MenuItem>
      {enablePatchThru ? (
        <MenuItem value="PATCH_THRU">
          Patch call through to target number
        </MenuItem>
      ) : null}
      {values.questions
        .map(({ key, name }, index) => ({
          label: `Go to Question ${index + 1} ${name ? `(${name})` : ""}`,
          value: key
        }))
        .filter(({ value }) => value !== questionKey)
        .map(({ value, label }) => (
          <MenuItem value={value} key={value}>
            {label}
          </MenuItem>
        ))}
      <MenuItem value="__new__">+ New Question</MenuItem>
    </FormikSelect>
  );
}
